import _ from 'lodash';
import { ISpecialty } from './IAlliedDisciplineAndSpecialties';
import { IFieldOptions } from './IFieldOptions';

export const anyJobType = (checked: boolean) => {
  return {
    isActive: checked,
    note: 'Any Job Type',
    type: 'Any Job Type',
    typeId: 0,
  };
};

export const anyShiftTime = (checked: boolean) => {
  return { isActive: checked, type: 'Any Shift Time', typeId: 0 };
};

export const anyShiftLength = (checked: boolean) => {
  return { isActive: checked, type: 'Any Shift Length', typeId: 0 };
};

export const anyFacilityType = (checked: boolean) => {
  return { isActive: checked, type: 'Any Facility Type', typeId: 0 };
};

export const areAllOptionsChecked = (
  optionList: IFieldOptions[],
  startIndex: number = 1,
): boolean => {
  let allChecked = true;
  optionList.forEach((option, index) => {
    if (index > startIndex - 1 && !option.isActive) {
      allChecked = false;
    }
  });
  return allChecked;
};

export const areAllOptionsUnchecked = (
  optionList: IFieldOptions[],
  startIndex: number = 1,
): boolean => {
  let allUnchecked = true;
  optionList.forEach((option, index) => {
    if (index > startIndex - 1 && option.isActive) {
      allUnchecked = false;
      return;
    }
  });
  return allUnchecked;
};

export const allSpecialtiesChecked = (specialties: ISpecialty[]): boolean => {
  let allChecked = true;
  for (let i = 0; i < specialties.length; ++i) {
    if (!specialties[i].checked) {
      allChecked = false;
      break;
    }
  }
  return allChecked;
};

export const alterAllOptions = (
  optionList: IFieldOptions[],
  toValue: boolean,
): IFieldOptions[] => {
  const optList = _.cloneDeep(optionList);
  optList.forEach((option, index) => {
    if (index > 0) option.isActive = toValue;
  });
  return optList;
};

export const handleAnyChecked = (
  optionList: IFieldOptions[],
): IFieldOptions[] => {
  const optList = [...optionList];
  optList.forEach((option, index) => {
    if (option.typeId !== 0) option.isActive = false;
  });
  return optList;
};

export const handleAllChecked = (
  optionList: IFieldOptions[],
): IFieldOptions[] => {
  let optList = handleAnyChecked(optionList);
  let anyIdx = optList.findIndex(option => option.typeId === 0);
  if (anyIdx > -1) {
    optList[anyIdx].isActive = true;
  }
  return optList;
};
